import api from "../services/api";
import { getToken } from "../utils/storage";

export const listLocations = (queryParams) => {
    return api.get(`company/location/list${queryParams}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const getLocation = (queryParams) => {
    return api.get(`/company/location/details${queryParams}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const createNewLocation = (formData) => {
    return api.post('company/location/add',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
}

export const changeLocationStatus = ({ status, location_id }) => {
    return api.put('/company/location/deactivate',
        { status, location_id }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const updateLocation = (formData) => {
    return api.post('company/location/update',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const deleteLocation = ({ location_id }) => {
    return api.delete('/company/location/delete', {
        data: { location_id },
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

// Locations Camera
export const getLocationCameraList = (queryParams) => {
    return api.get(`/company/location/camera/list${queryParams}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

// Camera Recording
export const getCameraRecordingList = (queryParams) => {
    return api.get(`/common/cam_recording${queryParams}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const createNewLocationCamera = async (data) => {
    const response = await api.post('company/location/camera/add',
        { ...data }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
    await api.post(`https://viewport-rtsp.solidappmaker.in/api/startAllProcesses`)
    return response
}

export const editLocationCamera = async (data) => {
    const response = await api.put('company/location/camera/update',
        { ...data }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
    await api.post(`https://viewport-rtsp.solidappmaker.in/api/startAllProcesses`)
    return response
}

export const deleteLocationCam = async ({ camera_id }) => {
    const response = await api.delete('/company/location/camera/delete', {
        data: { camera_id },
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
    await api.post(`https://viewport-rtsp.solidappmaker.in/api/startAllProcesses`)
    return response
}

// invitations
export const getLocationInvitationList = (queryParams) => {
    return api.get(`/company/location/invitation/list${queryParams}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const createNewLocationInvitation = (data) => {
    return api.post('company/location/invitation/send',
        { ...data }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const cancelLocationInvitation = (data) => {
    return api.post('/company/location/invitation/cancel',
        { ...data }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const createNewLocationInvitationBulk = (formData) => {
    return api.post('company/location/invitation/bulk-send',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getToken()}`
        }
    });
}